import PropTypes from 'prop-types';
import cn from 'classnames';

// JSDoc type definitions
/**
 * @typedef {Object} LdsTabPanelProps
 * @property {number|string} [tabId] - id of tab
 * @property {number|string} [activeTab] - Current active tab value
 * @property {React.ReactNode} [children] - Optional children
 */

/**
 * LdsTabPanel component
 * @param {LdsTabPanelProps & React.InputHTMLAttributes<HTMLInputElement>} props
 * @returns {React.JSX.Element} LdsTabPanel component
 */
export default function LdsTabPanel({ activeTab, tabId, children }) {
  return (
    <div
      className={cn(
        'lds-tab',
        {
          active: activeTab === tabId,
        }
      )}
      id={`tab-panel-${tabId}`}
      aria-labelledby={`tab-btn-${tabId}`}
      role="tabpanel"
    >
      {children}
    </div>
  );
}

LdsTabPanel.propTypes = {
  activeTab: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  tabId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};
